import { useState } from 'react'
import { useFoundry } from './hooks/useFoundry'
import { AssetBrowser } from './components/AssetBrowser'
import { AssetCreator } from './components/AssetCreator'
import { FrameCapture } from './components/FrameCapture'

type Tab = 'browse' | 'create' | 'capture'

export function FoundryTool() {
  const [tab, setTab] = useState<Tab>('browse')
  const foundry = useFoundry()

  return (
    <div className="h-full flex flex-col overflow-hidden">
      {/* Tab bar */}
      <div className="flex items-center gap-1 px-5 py-2 bg-forge-obsidian/50 border-b border-forge-slate/50">
        {([
          { id: 'browse' as const, label: 'Browse', icon: 'M4 6h16M4 10h16M4 14h16M4 18h16' },
          { id: 'create' as const, label: 'Create', icon: 'M12 5v14M5 12h14' },
          { id: 'capture' as const, label: 'Capture', icon: 'M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2zM12 17a4 4 0 100-8 4 4 0 000 8z' },
        ]).map((t) => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            className={`flex items-center gap-1.5 text-[12px] font-semibold px-4 py-2 rounded-md transition-colors ${
              tab === t.id
                ? 'bg-forge-ember/10 text-forge-ember'
                : 'text-forge-ash hover:text-forge-primary hover:bg-forge-basalt/50'
            }`}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d={t.icon} />
            </svg>
            {t.label}
          </button>
        ))}

        {foundry.error && (
          <div className="ml-auto flex items-center gap-2">
            <span className="text-[11px] text-forge-heat-critical truncate max-w-xs">{foundry.error}</span>
            <button onClick={foundry.dismissError} className="text-forge-heat-critical/60 hover:text-forge-heat-critical">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M18 6L6 18M6 6l12 12" />
              </svg>
            </button>
          </div>
        )}
      </div>

      {/* Tab content */}
      {tab === 'browse' && (
        <AssetBrowser
          assets={foundry.assets}
          loading={foundry.loading}
          filterType={foundry.filterType}
          setFilterType={foundry.setFilterType}
          filterTags={foundry.filterTags}
          setFilterTags={foundry.setFilterTags}
          searchQuery={foundry.searchQuery}
          setSearchQuery={foundry.setSearchQuery}
          onUpdate={foundry.updateAsset}
          onDelete={foundry.deleteAsset}
        />
      )}

      {tab === 'create' && (
        <AssetCreator
          generating={foundry.generating}
          onGenerate={foundry.generateAsset}
        />
      )}

      {tab === 'capture' && (
        <FrameCapture onCapture={foundry.captureFrame} />
      )}
    </div>
  )
}
